import { render, staticRenderFns } from "./ClientSupportContacts.vue?vue&type=template&id=f4f8bb36&scoped=true"
import script from "./ClientSupportContacts.vue?vue&type=script&lang=js"
export * from "./ClientSupportContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f8bb36",
  null
  
)

export default component.exports